/* eslint-disable global-require */
import angular from 'angular';
import './file-input.styles.scss';

export default angular
  .module('directives.file', [])
  .directive('fsFile', (numberConversionService) => {
    'ngInject';

    return {
      controllerAs: 'vm',
      controller: 'fileController',
      restrict: 'E',
      replace: true,
      scope: {
        fsModel: '=', // data binding of file
        types: '=', // the file types, the user can select
        allowCustom: '=', // when true, allows the user to specify own file type
        acceptFileTypes: '@',
        maxFileSize: '=',
      },
      templateUrl: require('./file-input.template.html'),
      link: (scope, element) => {
        const uuid = numberConversionService.generateUUID();
        const progressbarId = `progressBar-${uuid}`;
        const fileInputId = `fileInput-${uuid}`;
        const fileTypeInputId = `fileType-${uuid}`;

        scope.setProgressBarId(progressbarId);
        scope.uuid = uuid;        

        // Event listener for file dialogue and fileType select
        element.on('change', (event) => {
          if (event.target.id === fileInputId) scope.setFile(event.target.files);
          if (event.target.id === fileTypeInputId) scope.setFileType(event.target.value);
        });

        // Listener for two way model binding
        scope.$watch('exportFile', (newValue) => {
          scope.fsModel = newValue;
        });
      },
    };
  })
  .controller('fileController', (
    $scope,
    interfaceService,
    stringService,
    toastService,
  ) => {
    'ngInject';

    $scope.customFileType = '';
    $scope.fileType = '';
    $scope.exportFile = {
      progressBar: null,
      fileType: '',
      file: null,
    };

    const init = () => {
      if ($scope.types === undefined) $scope.types = [];
      if ($scope.allowCustom) $scope.types.push('Anderes Dokument');
      $scope.singleFileType = $scope.types.length === 1;
      if ($scope.singleFileType) {
        $scope.setFileType($scope.types[0]);
      }

      $scope.fileTypes = $scope.types;
    };

    /**
     * Depending on the user's selection of `fileType` an additonal input will be shown.
     */
    const toggleCustomFileTypeInput = (fileType) => {
      $scope.showCustomFileType = fileType === 'Anderes Dokument';
    };

    /**
     * @param {FileList} fileList
     */
    $scope.setFile = (fileList) => {
      if (fileList.length === 0) return;
      const file = fileList[0];

      $scope.exportFile.fileSize = (file.size / (1024 * 1024)).toFixed(2);
      if ($scope.maxFileSize && $scope.exportFile.fileSize > $scope.maxFileSize) {
        toastService.toast('error', 'Die Datei ist zu groß.');
        return;
      }

      $scope.exportFile.file = file;
      $scope.exportFile.extension = stringService.getExtensionFromFileName(file.name);
      $scope.exportFile.fileSize = (file.size / (1024 * 1024)).toFixed(2);

      $scope.fsModel = $scope.exportFile;
      interfaceService.applyScope($scope);
    };

    /**
     * @param {string} newFileType
     */
    $scope.setFileType = (newFileType) => {
      toggleCustomFileTypeInput(newFileType);

      $scope.fileType = newFileType;
      $scope.exportFile.fileType = newFileType;
      $scope.fsModel = $scope.exportFile;
      interfaceService.applyScope($scope);
    };

    /**
     * @param {string} id
     */
    $scope.setProgressBarId = (id) => {
      $scope.progressBarId = id;
      $scope.exportFile.progressBar = id;
      $scope.fsModel = $scope.exportFile;
    };

    /**
     * Handler for custom fileType input field
     */
    $scope.updateCustomFileType = () => {
      $scope.exportFile.fileType = $scope.customFileType;
      $scope.fsModel = $scope.exportFile;
      interfaceService.applyScope($scope);
    };

    init();
  })
  .directive('validFile', () => ({
    require: 'ngModel',
    link(scope, el, attrs, ngModel) {
      ngModel.$render = function () {
        ngModel.$setViewValue(el.val());
      };

      el.bind('change', () => {
        scope.$apply(() => {
          ngModel.$render();
        });
      });
    },
  }))
  .name;
